import { render, staticRenderFns } from "./collectionScore.vue?vue&type=template&id=d17d17fa&scoped=true"
import script from "./collectionScore.vue?vue&type=script&lang=js"
export * from "./collectionScore.vue?vue&type=script&lang=js"
import style0 from "./collectionScore.vue?vue&type=style&index=0&id=d17d17fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17d17fa",
  null
  
)

export default component.exports